import { configureCompat } from 'vue';

configureCompat({
    MODE: 2,
    COMPONENT_FUNCTIONAL: false,
    CONFIG_DEVTOOLS: false,
    CONFIG_IGNORED_ELEMENTS: false,
    CONFIG_OPTION_MERGE_STRATS: false,
    CONFIG_PRODUCTION_TIP: false,
    CUSTOM_DIR: false,
    FILTERS: false,
    GLOBAL_DELETE: false,
    GLOBAL_EXTEND: false,
    GLOBAL_OBSERVABLE: false,
    GLOBAL_PRIVATE_UTIL: false,
    GLOBAL_PROTOTYPE: false,
    GLOBAL_SET: false,
    INSTANCE_CHILDREN: false,
    INSTANCE_DELETE: false,
    INSTANCE_EVENT_EMITTER: false,
    INSTANCE_SET: false,
    OPTIONS_BEFORE_DESTROY: false,
    OPTIONS_DATA_MERGE: false,
    OPTIONS_DESTROYED: false,
    WATCH_ARRAY: false,
    COMPONENT_V_MODEL: false,
});
